/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Row_AddressInputs */

const en_wb_operations_row_address = /** @type {(inputs: Wb_Operations_Row_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery address`)
};

const lv_wb_operations_row_address = /** @type {(inputs: Wb_Operations_Row_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piegādes adrese`)
};

/**
* | output |
* | --- |
* | "Delivery address" |
*
* @param {Wb_Operations_Row_AddressInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_row_address = /** @type {((inputs?: Wb_Operations_Row_AddressInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Row_AddressInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_row_address(inputs)
	return en_wb_operations_row_address(inputs)
});